module.exports = __webpack_public_path__ + "static/mastercard-0fd233a8cabfcae6883fa50b6cc51eac.png";